import { createLocalStorageInstance } from '../../helpers/localStorage';

// Mirrors posthog-js's own storage keys (`utils/survey-utils.ts` and
// `extensions/surveys/surveys-extension-utils.tsx`). We render surveys
// ourselves rather than through the SDK's popover, so the SDK's *write* paths
// for these keys never run — but its *read* paths (`getSurveySeen`,
// `hasWaitPeriodPassed`, both consulted by `getActiveMatchingSurveys`) still
// do. Writing them here re-arms gating the SDK already knows how to enforce.
const SURVEY_SEEN_PREFIX = 'seenSurvey_';
const lastSeenSurveyDate = createLocalStorageInstance('lastSeenSurveyDate', false);

/**
 * True when this device holds a pre-iteration-tracking dismissal for the survey.
 *
 * Before we started sending `$survey_iteration`, posthog-js recorded seen state
 * under the unsuffixed `seenSurvey_<id>` key and set the matching unsuffixed
 * person property — neither of which a recurring survey's targeting flag reads.
 * Those users dismissed the survey but stayed eligible for it. The SDK now
 * looks only for the suffixed `seenSurvey_<id>_<iteration>` key, so honour the
 * old one here rather than nagging people who already said no.
 */
export const hasLegacyDismissal = (surveyId: string): boolean => (
  createLocalStorageInstance(`${SURVEY_SEEN_PREFIX}${surveyId}`, false).get() != null
);

/**
 * Stamps "a survey was shown just now", which is what posthog-js's
 * `hasWaitPeriodPassed` reads to enforce a survey's
 * `conditions.seenSurveyWaitPeriodInDays` (7 days for NPS). Only the SDK's own
 * renderer writes this key, so without it the wait period never applies to
 * surveys we render.
 */
export const recordSurveyLastSeen = (): void => {
  lastSeenSurveyDate.set(new Date().toISOString());
};
